module.exports = __webpack_public_path__ + "static/media/w_logo.ef52c4ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/details/imgs/w_logo.png
// module id = 1160
// module chunks = 0